import { MenuItemAggregate } from '../../../../../aggregats/menu/menu-item.aggregate';
import {
  exportBpfSousMenuItem,
  statistiquesSousMenuItem
} from './sous-menu-items.constantes';

export const statistiquesMenuItem: MenuItemAggregate = new MenuItemAggregate('icon-stats-up', 'Statistiques', [
    exportBpfSousMenuItem,
    statistiquesSousMenuItem,
]);
